import type { IFallbackImageProps } from './FallbackImage'

import { styled } from '@linaria/react'
import { FallbackImageSizes } from './FallbackImage.h'

export const FallbackImageSC = styled.div<IFallbackImageProps>`
  font-size: ${({ size }) => size || FallbackImageSizes.M};
  color: ${({ color }) => `var(${color})`};
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${({ borders, borderColor }) =>
    `var(${borders}) solid var(${borderColor})`};
  border-radius: inherit;
  background-color: ${({ background }) => `var(${background})`};
`
